module.exports = __webpack_public_path__ + "img/about3.42a36f94.png";